var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 76,
    fill: "#15192A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.838 110.324V82.7059H127.261V110.324H121.838Z",
    fill: "#F7A600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6273 118.527H47V90.9096H58.1598C63.5835 90.9096 66.7437 93.9351 66.7437 98.6676C66.7437 101.731 64.7141 103.711 63.3093 104.37C64.9861 105.145 67.1326 106.89 67.1326 110.577C67.1326 115.734 63.5835 118.527 58.6273 118.527ZM57.7305 95.7203H52.4237V102.082H57.7305C60.0322 102.082 61.3201 100.801 61.3201 98.9C61.3201 97.0006 60.0322 95.7203 57.7305 95.7203ZM58.0811 106.93H52.4237V113.719H58.0811C60.5401 113.719 61.7089 112.168 61.7089 110.305C61.7089 108.443 60.5379 106.93 58.0811 106.93Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6754 107.201V118.527H78.29V107.201L69.9398 90.9096H75.8311L81.021 102.042L86.1323 90.9096H92.0235L83.6754 107.201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4 118.527H95.7726V90.9096H106.932C112.356 90.9096 115.516 93.9351 115.516 98.6676C115.516 101.731 113.487 103.711 112.082 104.37C113.759 105.145 115.905 106.89 115.905 110.577C115.905 115.734 112.356 118.527 107.4 118.527ZM106.503 95.7203H101.196V102.082H106.503C108.805 102.082 110.093 100.801 110.093 98.9C110.093 97.0006 108.805 95.7203 106.503 95.7203ZM106.854 106.93H101.196V113.719H106.854C109.313 113.719 110.482 112.168 110.482 110.305C110.482 108.443 109.313 106.93 106.854 106.93Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.742 95.7203V118.529H139.318V95.7203H132.06V90.9096H152V95.7203H144.742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.426e02726b0f0ca16ae22f5a782cf46a.svg";
export { ForwardRef as ReactComponent };